import type {
  IUserLocationChangeSubmitEvent,
  IUserLocationChangeSubmitInput,
} from '../types/clickEvents';

const userLocationChangeSubmit = (
  input: IUserLocationChangeSubmitInput,
): Omit<IUserLocationChangeSubmitEvent, 'event'> => ({
  linkDetails: input.linkDetails,
  locationChangeMethod: input.locationChangeMethod,
});

export default userLocationChangeSubmit;
